import * as i0 from '@angular/core';
import { Injectable, Component, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import * as i2 from '@angular/common';
import * as i3 from 'ngx-image-cropper';
import { ImageCropperModule } from 'ngx-image-cropper';
import * as i4 from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimengLibraryModule } from 'primeng-library';

class UploadSignatureLibraryService {
    constructor() { }
}
UploadSignatureLibraryService.ɵfac = function UploadSignatureLibraryService_Factory(t) { return new (t || UploadSignatureLibraryService)(); };
UploadSignatureLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: UploadSignatureLibraryService, factory: UploadSignatureLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadSignatureLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function UploadSignatureLibraryComponent_div_9_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " Unaccepted format!. Please upload a 'png' format file ");
    i0.ɵɵelementEnd();
} }
function UploadSignatureLibraryComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "label", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵelement(3, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 13);
    i0.ɵɵlistener("change", function UploadSignatureLibraryComponent_div_9_Template_input_change_4_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.fileChangeEvent($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 14);
    i0.ɵɵelementStart(6, "sup");
    i0.ɵɵtext(7, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, "png format only");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, UploadSignatureLibraryComponent_div_9_div_9_Template, 2, 0, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", ctx_r0.unacceptedFormat);
} }
function UploadSignatureLibraryComponent_div_10_div_1_img_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 28);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", ctx_r6.croppedImage, i0.ɵɵsanitizeUrl);
} }
function UploadSignatureLibraryComponent_div_10_div_1_button_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵtext(1, "Save Photo");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("mat-dialog-close", ctx_r7.croppedImage);
} }
function UploadSignatureLibraryComponent_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "image-cropper", 19);
    i0.ɵɵlistener("imageCropped", function UploadSignatureLibraryComponent_div_10_div_1_Template_image_cropper_imageCropped_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.imageCropped($event); })("imageLoaded", function UploadSignatureLibraryComponent_div_10_div_1_Template_image_cropper_imageLoaded_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.imageLoaded(); })("cropperReady", function UploadSignatureLibraryComponent_div_10_div_1_Template_image_cropper_cropperReady_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.cropperReady(); })("loadImageFailed", function UploadSignatureLibraryComponent_div_10_div_1_Template_image_cropper_loadImageFailed_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.loadImageFailed(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "input", 20);
    i0.ɵɵlistener("ngModelChange", function UploadSignatureLibraryComponent_div_10_div_1_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.zoom($event); })("ngModelChange", function UploadSignatureLibraryComponent_div_10_div_1_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r14 = i0.ɵɵnextContext(2); return ctx_r14.zoomVal = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 2);
    i0.ɵɵelementStart(4, "div", 21);
    i0.ɵɵelementStart(5, "i", 22);
    i0.ɵɵlistener("click", function UploadSignatureLibraryComponent_div_10_div_1_Template_i_click_5_listener() { i0.ɵɵrestoreView(_r9); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.rotateLeft(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 23);
    i0.ɵɵelementStart(7, "button", 24);
    i0.ɵɵlistener("click", function UploadSignatureLibraryComponent_div_10_div_1_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r9); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.resetImage(); });
    i0.ɵɵtext(8, "Reset");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 25);
    i0.ɵɵtemplate(10, UploadSignatureLibraryComponent_div_10_div_1_img_10_Template, 1, 1, "img", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 25);
    i0.ɵɵtemplate(12, UploadSignatureLibraryComponent_div_10_div_1_button_12_Template, 2, 1, "button", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("imageChangedEvent", ctx_r5.imageChangedEvent)("maintainAspectRatio", false)("aspectRatio", 4 / 2)("onlyScaleDown", true)("canvasRotation", ctx_r5.canvasRotation)("transform", ctx_r5.transform)("alignImage", "left");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r5.zoomVal);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", ctx_r5.croppedImage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.croppedImage);
} }
function UploadSignatureLibraryComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, UploadSignatureLibraryComponent_div_10_div_1_Template, 13, 10, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showCropperSection);
} }
class UploadSignatureLibraryComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.canvasRotation = 0;
        this.rotation = 0;
        this.scale = 1;
        this.showCropper = false;
        this.containWithinAspectRatio = false;
        this.transform = {};
        this.showCropperSection = true;
        this.showFileUploadSection = true;
        this.zoomVal = 1;
        this.unacceptedFormat = false;
        this.previousVal = this.zoomVal;
    }
    ngOnInit() {
    }
    onNoClick() {
        this.dialogRef.close();
    }
    uploadProfileImage() {
        this.showCropperSection = false;
    }
    fileChangeEvent(event) {
        this.imageChangedEvent = event;
        const type = 'image/png';
        if (!this.imageChangedEvent.target.files[0].type.match(type)) {
            this.unacceptedFormat = true;
            this.showFileUploadSection = true;
            return;
        }
        this.showFileUploadSection = false;
    }
    imageCropped(event) {
        this.croppedImage = event.base64;
        // this.croppedImage = base64ToFile(event.base64);
    }
    imageLoaded() {
        // show cropper
        //console.log("image ready");
    }
    cropperReady() {
        // cropper ready
        //console.log("cropper ready");
    }
    loadImageFailed() {
        // show message
    }
    rotateLeft() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }
    rotateRight() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }
    flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = Object.assign(Object.assign({}, this.transform), { flipH: flippedV, flipV: flippedH });
    }
    flipHorizontal() {
        this.transform = Object.assign(Object.assign({}, this.transform), { flipH: !this.transform.flipH });
    }
    flipVertical() {
        this.transform = Object.assign(Object.assign({}, this.transform), { flipV: !this.transform.flipV });
    }
    resetImage() {
        this.scale = 1;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
    }
    zoom(event) {
        if (this.previousVal > event) {
            this.zoomOut();
        }
        else {
            this.zoomIn();
        }
        this.previousVal = event; //IM-4239
    }
    zoomOut() {
        this.scale -= .1;
        this.transform = Object.assign(Object.assign({}, this.transform), { scale: this.scale });
    }
    zoomIn() {
        this.scale += .1;
        this.transform = Object.assign(Object.assign({}, this.transform), { scale: this.scale });
    }
    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }
    updateRotation() {
        this.transform = Object.assign(Object.assign({}, this.transform), { rotate: this.rotation });
    }
}
UploadSignatureLibraryComponent.ɵfac = function UploadSignatureLibraryComponent_Factory(t) { return new (t || UploadSignatureLibraryComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
UploadSignatureLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: UploadSignatureLibraryComponent, selectors: [["upload-signature-library"]], decls: 11, vars: 2, consts: [[1, "modalBoxContainer"], [1, "modelTitleBox"], [1, "row"], [1, "col-11"], [1, "col-1", "rounded-circle"], [1, "fa", "fa-close", 2, "font-size", "24px", "font-weight", "500", 3, "mat-dialog-close"], [1, "dialogContentBox"], ["style", "height: 313px;", 4, "ngIf"], [4, "ngIf"], [2, "height", "313px"], ["for", "file-input"], [1, "center-icon"], [1, "fa", "fa-cloud-upload", 2, "font-size", "96px", "color", "blue"], ["id", "file-input", "type", "file", 1, "hiddenFile", 3, "change"], [1, "hint"], ["class", "error", 4, "ngIf"], [1, "error"], ["style", "width:100%;height:206px", 4, "ngIf"], [2, "width", "100%", "height", "206px"], ["format", "png", 3, "imageChangedEvent", "maintainAspectRatio", "aspectRatio", "onlyScaleDown", "canvasRotation", "transform", "alignImage", "imageCropped", "imageLoaded", "cropperReady", "loadImageFailed"], ["type", "range", "id", "customRange1", 1, "custom-range", 3, "ngModel", "ngModelChange"], [1, "col-1"], [1, "fa", "fa-rotate-right", 2, "font-size", "24px", 3, "click"], [1, "col-3"], [1, "btn", "btn-primary", 3, "click"], [1, "col-4"], ["class", "", 3, "src", 4, "ngIf"], ["class", "btn btn-primary", 3, "mat-dialog-close", 4, "ngIf"], [1, "", 3, "src"], [1, "btn", "btn-primary", 3, "mat-dialog-close"]], template: function UploadSignatureLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "h3");
        i0.ɵɵtext(5, "Upload Files");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelement(7, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, UploadSignatureLibraryComponent_div_9_Template, 10, 1, "div", 7);
        i0.ɵɵtemplate(10, UploadSignatureLibraryComponent_div_10_Template, 2, 1, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.showFileUploadSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showFileUploadSection);
    } }, directives: [i1.MatDialogClose, i2.NgIf, i3.ImageCropperComponent, i4.RangeValueAccessor, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel], styles: [".modalBoxContainer[_ngcontent-%COMP%]{padding:10px!important}.modalBoxContainer[_ngcontent-%COMP%]   .hint[_ngcontent-%COMP%]{display:block!important;font-size:12px;color:red}.modalBoxContainer[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{font-size:12px;color:red;text-align:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadSignatureLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'upload-signature-library',
                templateUrl: 'upload-signature-library.component.html',
                styleUrls: ['upload-signature-library.component.scss'],
            }]
    }], function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class UploadSignatureLibraryModule {
}
UploadSignatureLibraryModule.ɵfac = function UploadSignatureLibraryModule_Factory(t) { return new (t || UploadSignatureLibraryModule)(); };
UploadSignatureLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: UploadSignatureLibraryModule });
UploadSignatureLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] }
    ], imports: [[PrimengLibraryModule, ReactiveFormsModule, MatDialogModule, ImageCropperModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UploadSignatureLibraryModule, { declarations: [UploadSignatureLibraryComponent], imports: [PrimengLibraryModule, ReactiveFormsModule, MatDialogModule, ImageCropperModule], exports: [UploadSignatureLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadSignatureLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UploadSignatureLibraryComponent
                ],
                imports: [PrimengLibraryModule, ReactiveFormsModule, MatDialogModule, ImageCropperModule
                ],
                providers: [
                    { provide: MatDialogRef, useValue: {} },
                    { provide: MAT_DIALOG_DATA, useValue: [] }
                ],
                exports: [
                    UploadSignatureLibraryComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of upload-signature-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UploadSignatureLibraryComponent, UploadSignatureLibraryModule, UploadSignatureLibraryService };
//# sourceMappingURL=upload-signature-library.js.map
